import StyledSvg from 'icons/StyledSvg';
import { IconProps } from 'icons/types';

export const Magnifier = ({ color, size, x = '0px', y = '0px', scale = 0 }: IconProps) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width={size || '20px'}
      height={size || '20px'}
      color={color || 'currentColor'}
      scale={scale || 0}
      x={x}
      y={y}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M18.2385 19.0511L18.2915 19.1042L18.3445 19.0511L19.0516 18.344L19.1047 18.291L19.0516 18.238L14.6346 13.821C15.8143 12.4541 16.5277 10.6735 16.5277 8.7263C16.5277 4.41778 13.0349 0.925 8.7263 0.925C4.41778 0.925 0.925 4.41778 0.925 8.7263C0.925 13.0349 4.41778 16.5277 8.7263 16.5277C10.6737 16.5277 12.4546 15.8141 13.8215 14.6341L18.2385 19.0511ZM2.075 8.7263C2.075 5.05291 5.05291 2.075 8.7263 2.075C12.3998 2.075 15.3777 5.05291 15.3777 8.7263C15.3777 12.3998 12.3998 15.3777 8.7263 15.3777C5.05291 15.3777 2.075 12.3998 2.075 8.7263Z"
        fill={color || 'currentColor'}
        stroke={color || 'currentColor'}
        strokeWidth="0.15"
      />
    </StyledSvg>
  );
};
